import { render, staticRenderFns } from "./sysDetails.vue?vue&type=template&id=3198effc&scoped=true"
import script from "./sysDetails.vue?vue&type=script&lang=js"
export * from "./sysDetails.vue?vue&type=script&lang=js"
import style0 from "./sysDetails.vue?vue&type=style&index=0&id=3198effc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198effc",
  null
  
)

export default component.exports